import { useState } from "react";

export enum States {
  Incomplete = "INCOMPLETE",
  InProgress = "IN_PROGRESS",
  Complete = "COMPLETE",
}

export function usePersistedState(key: string, initialValue: States) {
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      if (key) {
        const item = window.localStorage.getItem(key);
        console.log(
          "item",
          key,
          window.localStorage.getItem(key),
          item !== null,
          initialValue
        );

        return item !== null ? item : initialValue;
      }
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that
  // persists the new value to localStorage.
  const setValue = (value: string) => {
    try {
      console.log("value", value);
      setStoredValue(value);
      window.localStorage.setItem(key, value);
    } catch (error) {
      // A more advanced implementation to handle the error case
      console.log(error);
    }
  };

  return [storedValue, setValue] as const;
}
